import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { useSeo } from "./lib/seo";
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Situations from './components/Situations';
import Benefits from './components/Benefits';
import Approach from './components/Approach';
import CaseStudies from './components/CaseStudies';
import WhitepaperCTA from './components/WhitepaperCTA';
import BlogSection from './components/BlogSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import CookieNotice from './components/CookieNotice';
import BlogAdmin from './pages/BlogAdmin';
import BlogArticle from './pages/BlogArticle';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
// Blockchain POC temporarily disabled for deployment
// import BlockchainPOC from './pages/BlockchainPOC';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const location = useLocation();

  useSeo({
    title: 'Smart Post Solution | Versandlogistik & Briefkonsolidierung',
    description: 'Smart Post Solution - Senior Consultant für Briefkonsolidierung, Versandlogistik und Poststellenorganisation. Nachhaltige Kostensenkung durch Transparenz und Expertise.',
    canonical: 'https://smart-post-solution.de/',
    noindex: false,
  });

  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    let tries = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      } else if (tries++ < 20) {
        setTimeout(tryScroll, 100);
      }
    };
    tryScroll();
  }, [location.hash, location.key]);

  return (
    <>
      <Header />
      <Hero />
      <Stats />
      <AboutUs />
      <Services />
      <CaseStudies />
      <Situations />
      <Benefits />
      <Approach />
      <WhitepaperCTA />
      <BlogSection />
      <Contact />
      <Footer />
      <Chatbot />
      <CookieNotice />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/blog-admin" element={<BlogAdmin />} />
          {/* Blockchain POC route temporarily disabled for deployment */}
          {/* <Route path="/blockchain-poc" element={<BlockchainPOC />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;